module.exports = __webpack_public_path__ + "img/question-qita-active.53132dfd.png";